<template>
  <div class="content-center-wrapper">
    <div class="white-container d-flex align-items-center justify-content-center">
      <div class="col-5">
        <div>
          <center class="mb-4">
            <img src="@/assets/img/logos/qqq.png" height="auto" width="150" />
          </center>

          <div class="mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="org_name"
                  id="OrganizationName"
                  name="Organization Name"
                  v-validate="{required: 'required', regex:/^[a-zA-Z0-9 ]*$/}"
                />
                <label for="OrganizationName">Organization Name</label>
              </div>
              <Tooltip :title="`To start with we need your organization name. Make sure you enter complete organization name.`"  />
            </div>

            <p v-if="submitted && errors.has('Organization Name')" class="error_message">
              <!-- {{ item.fieldname }} -->
              {{ errors.first(`${'Organization Name'}`)}}
            </p>
            <!-- <p v-if="submitted && org_name == null" class="error_msg mb-3">Invalid Organization Name</p> -->
          </div>

          <div class="mb-4">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  type="text"
                  v-model="email"
                  id="EmailAddress"
                  name="EmailAddress"
                  v-validate="'required|email'"
                />
                <label for="EmailAddress">Email Address</label>
              </div>
              <Tooltip :title="`Provide your email address so that we can send you the trial key to proceed with installation.`"  />
            </div>
            <p v-if="submitted && errors.has('EmailAddress')" class="error_message">
              <!-- {{ item.fieldname }} -->
              {{ errors.first(`${'EmailAddress'}`)}}
            </p>
            <!-- <p v-if="submitted && email == null" class="error_msg mb-3">Invalid Valid Email</p> -->
          </div>

          <div class="text-center">
            <router-link class="btn-blue-lg w-50" @click.native="onSubmit()" to>Proceed</router-link>
            <!-- <input type="submit" value="Activate" class="btn-blue-lg w-50"> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SetupService from "@/services/SetupService.js";
export default {
  data() {
    return {
      org_name: null,
      email: null,
      submitted: false
    };
  },
  methods: {
    onSubmit: function() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          //   this.submitted = true;
          if (this.email !== null) {
            let payload = {
              org_name: this.org_name,
              email: this.email
            };
            SetupService.SendMail(payload)
              .then(response => {
                const { data } = response;
                if (data && data.status) {
                  this.secureStore.set("ORGNAME", this.org_name);
                  this.$router.replace({
                    path: "enter-trial-key"
                  });
                } else {
                  this.$toasted.show(data.message);
                }
              })
              .catch(error => {
                this.$toasted.show(error);
              });
          }
        }
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Installation/activateKey.vue